import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import {
  CMP_PERMISSION_PLACE_ORDERS,
  CMP_PERMISSION_PURCHASE_PRODUCTS,
  CMP_PERMISSION_VIEW_SHOP
} from "@/components/organisations/constants";

/**
 * Hook to check shop-related CMP permissions for the current organisation
 *
 * @returns {Object} Permission flags
 * @returns {boolean} canViewShop - User can view shop and products
 * @returns {boolean} canPlaceOrders - User can add items to basket, modify basket, and complete checkout
 * @returns {boolean} canPurchase - User can see products as purchasable (controls product availability)
 */
export function useShopPermissions() {
  const { permissions = [] } = useOrganisationContext();

  return {
    canViewShop: permissions.includes(CMP_PERMISSION_VIEW_SHOP),
    canPlaceOrders: permissions.includes(CMP_PERMISSION_PLACE_ORDERS),
    canPurchase: permissions.includes(CMP_PERMISSION_PURCHASE_PRODUCTS)
  };
}
